/* eslint-disable react/display-name */
/* eslint-disable camelcase */
/* eslint-disable comma-dangle */

import React from 'react';
import dynamic from 'next/dynamic';
import ExampleLoading from 'react-scale/components/website/index/Products/examples/exampleLoading';

const TaskResponseCuboidAnnotation = dynamic(
  () => import('react-scale/components/website/index/Products/examples/tasks/cuboidannotation'),
  {
    loading: () => <ExampleLoading />,
    ssr: false
  }
);

const response = {
  annotations: [
    {
      label: 'taxi',
      vertices: [
        {
          type: 'vertex',
          x: 1095,
          y: 484.66666666666663,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 1095,
          y: 906,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 1411.6666666666667,
          y: 484.66666666666663,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 1411.6666666666667,
          y: 906,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 852,
          y: 489.66666666666663,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 852,
          y: 835,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 1095,
          y1: 484.66666666666663,
          x2: 1411.6666666666667,
          y2: 484.66666666666663,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 1411.6666666666667,
          y1: 484.66666666666663,
          x2: 1411.6666666666667,
          y2: 906,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 1411.6666666666667,
          y1: 906,
          x2: 1095,
          y2: 906,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 1095,
          y1: 906,
          x2: 1095,
          y2: 484.66666666666663,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 1095,
          y1: 484.66666666666663,
          x2: 852,
          y2: 489.66666666666663,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 852,
          y1: 489.66666666666663,
          x2: 852,
          y2: 835,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 852,
          y1: 835,
          x2: 1095,
          y2: 906,
          description: 'side-bottom'
        }
      ]
    },
    {
      label: 'taxi',
      vertices: [
        {
          type: 'vertex',
          x: 1460.6666666666667,
          y: 548.6666666666666,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 1460.6666666666667,
          y: 855.3333333333334,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 1712.3333333333333,
          y: 548.6666666666666,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 1712.3333333333333,
          y: 855.3333333333334,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 1173.6666666666667,
          y: 544.6666666666666,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 1173.6666666666667,
          y: 801.3333333333334,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 1460.6666666666667,
          y1: 548.6666666666666,
          x2: 1712.3333333333333,
          y2: 548.6666666666666,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 1712.3333333333333,
          y1: 548.6666666666666,
          x2: 1712.3333333333333,
          y2: 855.3333333333334,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 1712.3333333333333,
          y1: 855.3333333333334,
          x2: 1460.6666666666667,
          y2: 855.3333333333334,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 1460.6666666666667,
          y1: 855.3333333333334,
          x2: 1460.6666666666667,
          y2: 548.6666666666666,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 1460.6666666666667,
          y1: 548.6666666666666,
          x2: 1173.6666666666667,
          y2: 544.6666666666666,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 1173.6666666666667,
          y1: 544.6666666666666,
          x2: 1173.6666666666667,
          y2: 801.3333333333334,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 1173.6666666666667,
          y1: 801.3333333333334,
          x2: 1460.6666666666667,
          y2: 855.3333333333334,
          description: 'side-bottom'
        }
      ]
    },
    {
      label: 'train',
      vertices: [
        {
          type: 'vertex',
          x: 449.3333333333333,
          y: 142,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 449.3333333333333,
          y: 1004.3333333333334,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 1052.6666666666667,
          y: 142,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 1052.6666666666667,
          y: 1004.3333333333334,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 255.33333333333331,
          y: 213,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 255.33333333333331,
          y: 848.3333333333334,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 449.3333333333333,
          y1: 142,
          x2: 1052.6666666666667,
          y2: 142,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 1052.6666666666667,
          y1: 142,
          x2: 1052.6666666666667,
          y2: 1004.3333333333334,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 1052.6666666666667,
          y1: 1004.3333333333334,
          x2: 449.3333333333333,
          y2: 1004.3333333333334,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 449.3333333333333,
          y1: 1004.3333333333334,
          x2: 449.3333333333333,
          y2: 142,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 449.3333333333333,
          y1: 142,
          x2: 255.33333333333331,
          y2: 213,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 255.33333333333331,
          y1: 213,
          x2: 255.33333333333331,
          y2: 848.3333333333334,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 255.33333333333331,
          y1: 848.3333333333334,
          x2: 449.3333333333333,
          y2: 1004.3333333333334,
          description: 'side-bottom'
        }
      ]
    },
    {
      label: 'car',
      vertices: [
        {
          type: 'vertex',
          x: 138.5,
          y: 493,
          description: 'face-topleft'
        },
        {
          type: 'vertex',
          x: 138.5,
          y: 680,
          description: 'face-bottomleft'
        },
        {
          type: 'vertex',
          x: 289.5,
          y: 493,
          description: 'face-topright'
        },
        {
          type: 'vertex',
          x: 289.5,
          y: 680,
          description: 'face-bottomright'
        },
        {
          type: 'vertex',
          x: 117.5,
          y: 493,
          description: 'side-topcorner'
        },
        {
          type: 'vertex',
          x: 117.5,
          y: 657,
          description: 'side-bottomcorner'
        }
      ],
      edges: [
        {
          type: 'edge',
          x1: 138.5,
          y1: 493,
          x2: 289.5,
          y2: 493,
          description: 'face-top'
        },
        {
          type: 'edge',
          x1: 289.5,
          y1: 493,
          x2: 289.5,
          y2: 680,
          description: 'face-right'
        },
        {
          type: 'edge',
          x1: 289.5,
          y1: 680,
          x2: 138.5,
          y2: 680,
          description: 'face-bottom'
        },
        {
          type: 'edge',
          x1: 138.5,
          y1: 680,
          x2: 138.5,
          y2: 493,
          description: 'face-left'
        },
        {
          type: 'edge',
          x1: 138.5,
          y1: 493,
          x2: 117.5,
          y2: 493,
          description: 'side-top'
        },
        {
          type: 'edge',
          x1: 117.5,
          y1: 493,
          x2: 117.5,
          y2: 657,
          description: 'side-back'
        },
        {
          type: 'edge',
          x1: 117.5,
          y1: 657,
          x2: 138.5,
          y2: 680,
          description: 'side-bottom'
        }
      ]
    }
  ]
};

export default () => (
  <TaskResponseCuboidAnnotation
    hover
    imageURL="/static/img/website/solutions/self-driving-cars/slider/slide-2.jpg"
    annotations={response.annotations}
    bgTransparent
    responsive
    rounded
  />
);
